module.exports = __webpack_public_path__ + "img/美团_03.bb77ad66.jpg";